export type DiscoverIconKey =
	| "gift"
	| "sparkles"
	| "calendar"
	| "bot"
	| "send"
	| "bar-chart"
	| "arrow-right-left"
	| "image"
	| "users"
	| "shield-alert";

export interface DiscoverItem {
	id: string;
	name: string;
	nameEn: string;
	description: string;
	descriptionEn: string;
	href: string;
	icon: DiscoverIconKey;
	external?: boolean;
}

export interface DiscoverSection {
	id: string;
	title: string;
	titleEn: string;
	items: DiscoverItem[];
}

export const discoverSections: DiscoverSection[] = [
	{
		id: "activities",
		title: "活动",
		titleEn: "Activities",
		items: [
			{
				id: "lucky-gift",
				name: "奥丁红包",
				nameEn: "Lucky Gift",
				description: "红包广场、动态与我的红包",
				descriptionEn: "Gift plaza, feed, and my gifts",
				href: "/plaza/lucky-gift",
				icon: "gift",
			},
			{
				id: "lucky-wheel",
				name: "奥丁宝符炉",
				nameEn: "Lucky Wheel",
				description: "宝符炉玩法与开奖记录",
				descriptionEn: "Lucky wheel gameplay and records",
				href: "/plaza/lucky-wheel",
				icon: "sparkles",
			},
			{
				id: "activities",
				name: "空投活动",
				nameEn: "Airdrop Activities",
				description: "站内活动与空投管理",
				descriptionEn: "On-site campaigns and airdrops",
				href: "/activities",
				icon: "calendar",
			},
		],
	},
	{
		id: "transfer-tools",
		title: "转账工具",
		titleEn: "Transfer Tools",
		items: [
			{
				id: "batch-airdrop",
				name: "批量空投",
				nameEn: "Batch Airdrop",
				description: "批量发放与名单管理",
				descriptionEn: "Bulk distribution and address management",
				href: "/tools/batch-airdrop",
				icon: "gift",
			},
			{
				id: "single-transfer",
				name: "单个转账",
				nameEn: "Single Transfer",
				description: "单地址转账工具",
				descriptionEn: "Single-address transfer tool",
				href: "/tools/single-transfer",
				icon: "send",
			},
			{
				id: "internal-transfer-browser",
				name: "内部转账浏览器",
				nameEn: "Internal Transfer Browser",
				description: "查看 Odin 内部转账记录",
				descriptionEn: "Browse Odin internal transfer records",
				href: "https://it.odin.baby",
				icon: "arrow-right-left",
				external: true,
			},
		],
	},
	{
		id: "monitoring-tools",
		title: "监控工具",
		titleEn: "Monitoring Tools",
		items: [
			{
				id: "frontrunner",
				name: "抢跑机器人",
				nameEn: "Frontrunner Bot",
				description: "策略抢跑与监控工作台",
				descriptionEn: "Frontrunning and monitoring workspace",
				href: "/tools/frontrunner",
				icon: "bot",
			},
			{
				id: "holdings-monitor",
				name: "持仓监控",
				nameEn: "Holdings Monitor",
				description: "地址持仓与快照监控",
				descriptionEn: "Address holdings and snapshot monitor",
				href: "/tools/holdings-monitor",
				icon: "bar-chart",
			},
			{
				id: "rune-snapshot",
				name: "Rune 快照",
				nameEn: "Rune Snapshot",
				description: "按动作 ID 还原持仓与 LP 快照",
				descriptionEn: "Rebuild holder and LP snapshots by action ID",
				href: "/tools/rune-snapshot",
				icon: "bar-chart",
			},
			{
				id: "rune-bridge",
				name: "符文桥",
				nameEn: "Rune Bridge",
				description: "Rune 相关桥接能力",
				descriptionEn: "Rune bridge utility",
				href: "/tools/rune-bridge",
				icon: "arrow-right-left",
			},
			{
				id: "rune-address",
				name: "Odin-Fomowell地址关联",
				nameEn: "Odin-Fomowell Address Links",
				description: "查询 BTC、Odin 与 Fomowell 关联身份",
				descriptionEn: "Look up BTC, Odin, and Fomowell linked identities",
				href: "/tools/rune-address",
				icon: "arrow-right-left",
			},
		],
	},
	{
		id: "community-tools",
		title: "社区工具",
		titleEn: "Community Tools",
		items: [
			{
				id: "poster",
				name: "海报工具",
				nameEn: "Poster Tool",
				description: "海报编辑与导出",
				descriptionEn: "Poster editing and export",
				href: "/tools/poster",
				icon: "image",
			},
		{
			id: "web3-builders-alliance",
			name: "Web3建设者联盟",
			nameEn: "Web3 Builders Alliance",
			description: "Web3 建设者社区入口",
			descriptionEn: "Community hub for Web3 builders",
			href: "https://www.web3build.vip",
			icon: "users",
			external: true,
		},
		{
			id: "event-tracking",
			name: "0401攻击事件追踪",
			nameEn: "0401 Incident Tracking",
			description: "查看事件时间线、资金流与公告",
			descriptionEn: "View the timeline, fund flows, and official updates",
			href: "/event",
			icon: "shield-alert",
		},
	],
	},
];

export const discoverActivePatterns = [
	"/discover",
	"/activities",
	"/plaza/lucky-gift",
	"/plaza/lucky-wheel",
	"/tools/frontrunner",
	"/tools/batch-airdrop",
	"/tools/single-transfer",
	"/tools/holdings-monitor",
	"/tools/rune-snapshot",
	"/tools/rune-bridge",
	"/tools/rune-address",
	"/tools/poster",
	"/event",
];

export const discoverInternalItems = discoverSections.flatMap((section) =>
	section.items.filter((item) => !item.external),
);
